var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _rect2, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _rect3, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 80,
    viewBox: "0 0 128 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 22,
    r: 2,
    transform: "rotate(90 43 22)",
    fill: "#002851"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 22,
    r: 2,
    transform: "rotate(90 30 22)",
    fill: "#002851"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 22,
    r: 2,
    transform: "rotate(90 18 22)",
    fill: "#002851"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 22,
    r: 2,
    transform: "rotate(90 82 22)",
    fill: "#002851"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 22,
    r: 2,
    transform: "rotate(90 69 22)",
    fill: "#002851"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 22,
    r: 2,
    transform: "rotate(90 56 22)",
    fill: "#002851"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 20,
    width: 20,
    height: 4,
    rx: 2,
    fill: "#002851"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 34,
    r: 2,
    transform: "rotate(90 51 34)",
    fill: "#5A748F"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 34,
    r: 2,
    transform: "rotate(90 38 34)",
    fill: "#5A748F"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 34,
    r: 2,
    transform: "rotate(90 26 34)",
    fill: "#5A748F"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 34,
    r: 2,
    transform: "rotate(90 90 34)",
    fill: "#5A748F"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 34,
    r: 2,
    transform: "rotate(90 77 34)",
    fill: "#5A748F"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 34,
    r: 2,
    transform: "rotate(90 64 34)",
    fill: "#5A748F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 32,
    width: 20,
    height: 4,
    rx: 2,
    fill: "#5A748F"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 58,
    r: 2,
    transform: "rotate(90 35 58)",
    fill: "#002851"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 58,
    r: 2,
    transform: "rotate(90 22 58)",
    fill: "#002851"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 58,
    r: 2,
    transform: "rotate(90 10 58)",
    fill: "#002851"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 58,
    r: 2,
    transform: "rotate(90 74 58)",
    fill: "#002851"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 58,
    r: 2,
    transform: "rotate(90 61 58)",
    fill: "#002851"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 58,
    r: 2,
    transform: "rotate(90 48 58)",
    fill: "#002851"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 56,
    width: 20,
    height: 4,
    rx: 2,
    fill: "#002851"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 46,
    r: 2,
    transform: "rotate(90 43 46)",
    fill: "#002851"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 46,
    r: 2,
    transform: "rotate(90 30 46)",
    fill: "#002851"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 46,
    r: 2,
    transform: "rotate(90 18 46)",
    fill: "#002851"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 46,
    r: 2,
    transform: "rotate(90 82 46)",
    fill: "#002851"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 46,
    r: 2,
    transform: "rotate(90 69 46)",
    fill: "#002851"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 46,
    r: 2,
    transform: "rotate(90 56 46)",
    fill: "#002851"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 44,
    width: 20,
    height: 4,
    rx: 2,
    fill: "#002851"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderList);
export default __webpack_public_path__ + "static/media/OrderList.7816d1de1033b7b7d9b2642ee9260932.svg";
export { ForwardRef as ReactComponent };